// extracted by mini-css-extract-plugin
export var brand = "brand-module--brand--YGh67";
export var brandImageLogo = "brand-module--brand-image-logo--d2QJF";
export var faqComponent = "brand-module--faqComponent--E3INe";
export var logoWrapper = "brand-module--logo-wrapper--uL2pI";
export var newsletter = "brand-module--newsletter--UIQ0p";
export var padding = "brand-module--padding--IzkDH";